import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		isIOS: /(iPhone|iPad)/gi.test(navigator.userAgent),
		isAndroid: /(Android)/gi.test(navigator.userAgent),
		isIE: /(MSIE|Trident)/gi.test(navigator.userAgent),
		isWindows: navigator.platform.indexOf('Win') > -1,

		region: environment.region,
		ipMembershipNo: 0,
		isVietnam: false,
		countryInfo: { country: 'US' },
		countryCode: '',
		gameList: [],
		heroBannerList: [],
		mediaList: [],
		config: null,
		employeeRecList: [],
		generalDepartmentsList: [],

		partnership: {
			introImage: '',
			introImageMobile: '',
			introVideo: null,
			introSummary: '',
			summary: '',
			contactType: '',
			detail: '',
			Children: [],
			name: '',
		},
	},
	getters: {
		cmsRegionCode: (state) => {
			if (state.region === 'sea' && state.isVietnam) {
				return 'vietnam';
			}
			return state.region;
		},
	},
	actions: {
		async checkCountryInfo({ commit }) {
			const { data } = await this._vm.$countryAPI.get('/no-auth/membership-no');
			commit('setCountryInfo', data);
		},
		async checkRegionInfo({ state, commit }) {
			if (state.region !== 'sea') return; // need to check (whether user ip country is Vietnam or not) only in sea region
			if (state.ipMembershipNo !== 0) return; // already fetched
			const { data } = await this._vm.$countryAPI.get('/no-auth/membership-no');
			commit('setRegionInfo', data);
		},
		async getHeroBannerList({ dispatch, commit, state, getters }) {
			if (state.heroBannerList.length > 0) return state.heroBannerList;
			await dispatch('checkRegionInfo');
			const { data } = await this._vm.$cdnAPI.get(`frontend/v3/${getters.cmsRegionCode}/hero-banners.json`);
			commit('setHeroBannerList', data);
		},
		async getGameList({ dispatch, commit, state, getters }) {
			if (state.gameList.length > 0) return state.gameList;
			await dispatch('checkRegionInfo');
			const { data } = await this._vm.$cdnAPI.get(`frontend/v3/${getters.cmsRegionCode}/gamelist.json`);
			commit('setGameList', data);
		},
		async getMediaList({ dispatch, commit, state, getters }) {
			if (state.mediaList.length > 0) return state.mediaList;
			await dispatch('checkRegionInfo');
			const { data } = await this._vm.$cdnAPI.get(`frontend/${getters.cmsRegionCode}/screenshots.json`);
			commit('setMediaList', data);
		},
		async getConfig({ dispatch, commit, state, getters }) {
			if (state.config !== null) return state.config;
			await dispatch('checkRegionInfo');
			const { data } = await this._vm.$cdnAPI.get(`frontend/v3/${getters.cmsRegionCode}/config.json`);
			commit('setConfig', data);
		},
		async getEmployeeRecList({ commit, state }) {
			if (state.employeeRecList.length > 0) return;
			const { data } = await this._vm.$cdnAPI.get('frontend/v3/employee-recognition/list.json');
			commit('setEmployeeRecList', data);
		},
		async getGeneralDepartmentsList({ commit, state }) {
			if (state.generalDepartmentsList.length > 0) return;
			const { data } = await this._vm.$cdnAPI.get('frontend/v3/employee-recognition/general-departments.json');
			commit('setGeneralDepartmentsList', data);
		},
		async getPartnership({ commit }) {
			const { data } = await this._vm.$cdnNexonstaticApi.get('/corporate/ms-partnership');
			commit('setPartnership', data);
		},
	},
	mutations: {
		setCountryInfo(state, value) {
			state.countryInfo = { country: value.country };
		},
		setRegionInfo(state, value) {
			state.ipMembershipNo = value.membershipNo;
			state.isVietnam = value.isVietnam;
		},
		setGameList(state, payload) {
			state.gameList = payload;
		},
		setHeroBannerList(state, payload) {
			state.heroBannerList = payload;
		},
		setMediaList(state, payload) {
			state.mediaList = payload;
		},
		setConfig(state, payload) {
			state.config = payload;
		},
		setEmployeeRecList(state, payload) {
			state.employeeRecList = payload;
		},
		setGeneralDepartmentsList(state, payload) {
			state.generalDepartmentsList = payload;
		},
		setPartnership(state, payload) {
			state.partnership = payload;
		},
	},
});
